import * as Yup from "yup";

export const reportFormValidation = Yup.object().shape({
  content: Yup.string().required("Content is required!"),
});
